// src/processors/template/template-content-processor.ts - Template Content Processing
import { XConVitePluginOptions } from '../../types';
import {Logger} from "../../utils/logger";

/**
 * Handles template content processing including minification and escaping
 */
export class TemplateContentProcessor {
    constructor(
        private options: Required<XConVitePluginOptions>,
        private logger: Logger
    ) {

    }
    /**
     * Process template content with proper JavaScript escaping for HTML files
     */
    processTemplateContent(content: string): string {
        let processed = content.trim();

        // Remove HTML comments if requested
        if (this.options.removeComments) {
            processed = this.removeHtmlComments(processed);
        }

        // Escape for template literal
        processed = this.escapeForTemplateLiteral(processed);

        // Minify template if requested
        if (this.options.minifyTemplates) {
            processed = this.minifyHtml(processed);
        }

        return processed;
    }

    /**
     * Remove HTML comments
     */
    private removeHtmlComments(content: string): string {
        return content.replace(/<!--[\s\S]*?-->/g, '');
    }

    /**
     * Escape content for template literal
     */
    private escapeForTemplateLiteral(content: string): string {
        return content
            .replace(/\\/g, '\\\\')        // Escape backslashes first
            .replace(/`/g, '\\`')          // Escape backticks for template literal
            .replace(/\$\{/g, '\\${');     // Escape template literal expressions
    }

    /**
     * Minify HTML while preserving structure for debugging
     */
    private minifyHtml(html: string): string {
        if (!this.options.minifyTemplates) {
            return html;
        }

        return html
            // Remove extra whitespace between tags but preserve line structure
            .replace(/>\s+</g, '><')
            // Collapse multiple spaces within text content
            .replace(/(\s{2,})/g, ' ')
            // Remove leading/trailing whitespace from lines
            .replace(/^\s+/gm, '')
            .replace(/\s+$/gm, '')
            // Preserve important newlines for debugging
            .replace(/(<\/[^>]+>)(\n)/g, '$1\n')
            .replace(/(<[^/>]+>)(\n)/g, '$1\n')
            .trim();
    }
}